"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ColorBrushPaintAlternate: ['color-brush-paint-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.833,22.28a2.846,2.846,0,0,1,1.3-3.008.846.846,0,0,0,.173-.127,6.681,6.681,0,0,0,.073-.914c.02-.423.043-.877.1-1.371a.249.249,0,0,0-.228-.28c-2.216-.174-3.4-.238-4.758-1.99a2.373,2.373,0,0,0-2.745-1.148A2.239,2.239,0,0,0,.292,14.588,2.988,2.988,0,0,0,.2,16.972c.875,2.567,4.753,5.708,7.624,6.422a.25.25,0,0,0,.281-.36A2.809,2.809,0,0,1,7.833,22.28Z', 'M23.1.782a1.655,1.655,0,0,0-2.223.7l-6,10.493a.25.25,0,0,0,.194.373,5.182,5.182,0,0,1,3.141,1.459.249.249,0,0,0,.4-.069L23.816,3.018A1.661,1.661,0,0,0,23.1.782Z', 'M15.06,13.857a3.655,3.655,0,0,0-4.081,3.16c-.059.463-.08.889-.1,1.284-.054,1.176-.079,1.713-.964,2.252a1.339,1.339,0,0,0,.517,2.471,7.856,7.856,0,0,0,1.055.071,7.149,7.149,0,0,0,4.383-1.461,5.961,5.961,0,0,0,2.349-3.7A3.655,3.655,0,0,0,15.06,13.857Z']],
  ColorPicker2Alternate: ['color-picker-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.793,12.207a1,1,0,0,0,1.414-1.414l-.641-.642a.249.249,0,0,1,0-.353l1.862-1.862a4.775,4.775,0,0,0,.353-6.717,4.777,4.777,0,0,0-6.718.353h0L14.2,3.434a.251.251,0,0,1-.354,0l-.641-.641a1,1,0,0,0-1.414,1.414Z', 'M11.714,6.275a.249.249,0,0,0-.353,0L9.6,8.038a.25.25,0,0,0,0,.353l1.755,1.755a.5.5,0,1,1-.707.707L8.891,9.1a.252.252,0,0,0-.354,0l-.939.94a.25.25,0,0,0,0,.353l1.755,1.755a.5.5,0,1,1-.707.707L6.891,11.1a.252.252,0,0,0-.354,0l-.939.94a.25.25,0,0,0,0,.353l1.755,1.755a.5.5,0,1,1-.707.707L4.891,13.1a.252.252,0,0,0-.354,0l-1.58,1.581a4.918,4.918,0,0,0-1.493,4.236L.437,19.94a1.5,1.5,0,0,0,0,2.121l1.5,1.5a1.5,1.5,0,0,0,2.121,0l1.026-1.025A4.919,4.919,0,0,0,9.32,21.043l8.405-8.4a.25.25,0,0,0,0-.353Z']],
  ColorBrushPaint1: ['color-brush-paint-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16,16.71a.5.5,0,0,0-.331.273,3.506,3.506,0,0,1-2,1.818,1,1,0,0,0-.667.942V21.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.5-.5H8.256a1,1,0,0,0,.943-.667,3.508,3.508,0,0,1,2.762-2.29.5.5,0,0,0,.419-.431,7.9,7.9,0,0,1,.168-.97.5.5,0,0,0-.529-.621A5.517,5.517,0,0,0,7.736,12.75.5.5,0,0,1,7.3,13H2a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2H13a2,2,0,0,0,2-2V20.7a.5.5,0,0,1,.25-.434,5.511,5.511,0,0,0,2.684-3.922.25.25,0,0,0-.371-.255A6.013,6.013,0,0,1,16,16.71Z', 'M23.807,2A1.317,1.317,0,0,0,21.569.614l-4.48,6.655a.249.249,0,0,0,.158.384,4.023,4.023,0,0,1,2.192,1.24.25.25,0,0,0,.4-.044Z', 'M17.022,8.9a2.791,2.791,0,0,0-3.293,2.184c-.066.328-.1.633-.137.914-.1.842-.154,1.1-.676,1.364a1.166,1.166,0,0,0,.292,2.178,5.766,5.766,0,0,0,1.176.123,5.228,5.228,0,0,0,2.885-.852,4.428,4.428,0,0,0,1.939-2.618A2.8,2.8,0,0,0,17.022,8.9Z']],
  ColorBrush3: ['color-brush-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.6,2.745A1.66,1.66,0,0,0,21.105.552L7.9,13.9a.251.251,0,0,0,.1.413A5.116,5.116,0,0,1,11.05,17a.249.249,0,0,0,.417.056Z', 'M9.793,17.909a3.65,3.65,0,0,0-6.742-.2c-.191.426-.334.827-.467,1.2-.394,1.11-.574,1.617-1.578,1.875A1.339,1.339,0,0,0,.781,23.3a7.521,7.521,0,0,0,3.138.7,7,7,0,0,0,2.47-.447A5.946,5.946,0,0,0,9.711,20.7,3.62,3.62,0,0,0,9.793,17.909Z']],
  ColorBucket1: ['color-bucket-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.868,14.326a1,1,0,0,0-1.735,0C19.159,16.025,18,18.273,18,19.334a3,3,0,1,0,6,0C24,18.275,22.841,16.026,21.868,14.326Z', 'M18.544,10.72a.929.929,0,0,0-.313-1.044L10.645,2.09a1.539,1.539,0,0,0-2.121,0L6.6,4.011a.25.25,0,0,1-.22.07L2.172,3.338a1,1,0,1,0-.347,1.968l7.94,1.4a.25.25,0,0,1,.2.29l-.143.808a.25.25,0,0,1-.29.2L3.772,6.992a.249.249,0,0,0-.22.07L.731,9.883a2.5,2.5,0,0,0,0,3.536L5.4,18.09a2.5,2.5,0,0,0,3.535,0L15.231,11.8a2.313,2.313,0,0,1,1.353-.561h1A.932.932,0,0,0,18.544,10.72Z']],
  ColorBucketBrush: ['color-bucket-brush', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.857,13.185A.25.25,0,0,1,4,13.411V18.75a1.5,1.5,0,0,0,3,0V13.411a.25.25,0,0,1,.143-.226,4.884,4.884,0,0,0,2.85-4.172.25.25,0,0,0-.25-.263H1.257a.25.25,0,0,0-.25.263A4.884,4.884,0,0,0,3.857,13.185Z', 'M11,1.25a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1L.967,7.538a.25.25,0,0,0,.247.212H9.786a.25.25,0,0,0,.247-.212Z', 'M17.5,7.75c-3.23,0-6.5,1.2-6.5,3.5v9c0,2.3,3.27,3.5,6.5,3.5s6.5-1.2,6.5-3.5v-9C24,8.952,20.73,7.75,17.5,7.75Zm4.5,8.5a2,2,0,0,1-4,0V12.992a.251.251,0,0,0-.264-.249c-.076,0-.154.007-.236.007-2.923,0-4.5-1.064-4.5-1.5s1.577-1.5,4.5-1.5,4.5,1.064,4.5,1.5Z']],
  ColorPaletteSample1: ['color-palette-sample-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.907,16.286l-1.348-4.815a2.5,2.5,0,0,0-3.081-1.734l-.754.211.527-.653a2.5,2.5,0,0,0-.377-3.515L14.982,2.642a2.5,2.5,0,0,0-3.516.376L10.445,4.285A.251.251,0,0,1,10,4.128V2.5A2.5,2.5,0,0,0,7.5,0h-5A2.5,2.5,0,0,0,0,2.5V18.807a5.145,5.145,0,0,0,4.511,5.17c.166.015.332.023.5.023C6,24,5.5,24,22.174,19.367A2.5,2.5,0,0,0,23.907,16.286ZM13.023,4.273a.5.5,0,0,1,.7-.075l3.893,3.139a.5.5,0,0,1,.074.7l-7.248,8.988A.25.25,0,0,1,10,16.871V8.11a.249.249,0,0,1,.056-.157ZM5,9a2,2,0,1,1-2,2A2,2,0,0,1,5,9ZM3,4.5a2,2,0,1,1,2,2A2,2,0,0,1,3,4.5Zm2,11a2,2,0,1,1-2,2A2,2,0,0,1,5,15.5Zm16.634,1.941L10.822,20.468a.25.25,0,0,1-.262-.4l5.95-7.377a.255.255,0,0,1,.127-.084l3.38-.946a.5.5,0,0,1,.616.347l1.348,4.815A.5.5,0,0,1,21.634,17.441Z']],
  ColorPaletteSample: ['color-palette-sample', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.3,24a1,1,0,0,0,.756-.345L22.523,9.277a2,2,0,0,0-.212-2.822L19.861,4.35a1,1,0,0,0-1.3,1.517l2.072,1.775a.5.5,0,0,1,.052.707l-7.8,9a.25.25,0,0,1-.423-.251L17.133,4.484a2,2,0,0,0-1.181-2.57L12.609.675a1,1,0,1,0-.7,1.875l2.876,1.065a.5.5,0,0,1,.295.643L10.478,16.677a.25.25,0,0,1-.485-.087V1.5A1.5,1.5,0,0,0,8.493,0h-6a1.5,1.5,0,0,0-1.5,1.5v21a1.5,1.5,0,0,0,1.5,1.5ZM3.493,9.75a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5Zm0-3.75V3a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5V6a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,3.493,6Zm0,10.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5Z']],
  ColorTubes: ['color-tubes', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.25,20a.25.25,0,0,0-.25.25V22.5A1.5,1.5,0,0,0,1.5,24h4A1.5,1.5,0,0,0,7,22.5V20.25A.25.25,0,0,0,6.75,20Z', 'M6.75,10A.25.25,0,0,0,7,9.75V7.5A1.5,1.5,0,0,0,5.5,6h-4A1.5,1.5,0,0,0,0,7.5V9.75A.25.25,0,0,0,.25,10Z', 'M0.000 11.000 L7.000 11.000 L7.000 19.000 L-0.000 19.000 Z', 'M1.5,5h4a.5.5,0,0,0,.483-.629l-.8-3.005A1.72,1.72,0,0,0,1.82,1.352l-.8,3.019A.5.5,0,0,0,1.5,5Z', 'M8.500 11.000 L15.500 11.000 L15.500 19.000 L8.500 19.000 Z', 'M15.25,10a.25.25,0,0,0,.25-.25V7.5A1.5,1.5,0,0,0,14,6H10A1.5,1.5,0,0,0,8.5,7.5V9.75a.25.25,0,0,0,.25.25Z', 'M8.75,20a.25.25,0,0,0-.25.25V22.5A1.5,1.5,0,0,0,10,24h4a1.5,1.5,0,0,0,1.5-1.5V20.25a.25.25,0,0,0-.25-.25Z', 'M10,5h4a.5.5,0,0,0,.483-.629l-.8-3.005a1.72,1.72,0,0,0-3.363-.014l-.8,3.019A.5.5,0,0,0,10,5Z', 'M17.000 11.000 L24.000 11.000 L24.000 19.000 L17.000 19.000 Z', 'M23.75,10A.25.25,0,0,0,24,9.75V7.5A1.5,1.5,0,0,0,22.5,6h-4A1.5,1.5,0,0,0,17,7.5V9.75a.25.25,0,0,0,.25.25Z', 'M17.25,20a.25.25,0,0,0-.25.25V22.5A1.5,1.5,0,0,0,18.5,24h4A1.5,1.5,0,0,0,24,22.5V20.25a.25.25,0,0,0-.25-.25Z', 'M18.5,5h4a.5.5,0,0,0,.483-.629l-.8-3.005a1.72,1.72,0,0,0-3.363-.014l-.8,3.019A.5.5,0,0,0,18.5,5Z']],
  ColorPickerAlternate: ['color-picker-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,9a1,1,0,0,0,0-2h-.75A.25.25,0,0,1,16,6.75V4.5A4.277,4.277,0,0,0,12,0,4.277,4.277,0,0,0,8,4.5V6.75A.25.25,0,0,1,7.75,7H7A1,1,0,0,0,7,9Z', 'M8.25,10.5a.25.25,0,0,0-.25.25v1a.25.25,0,0,0,.25.25H10.5a.5.5,0,0,1,0,1H8.25a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H10.5a.5.5,0,0,1,0,1H8.25a.25.25,0,0,0-.25.25V17.5a5.138,5.138,0,0,0,2,4.113V23a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V21.613A5.138,5.138,0,0,0,16,17.5V10.75a.25.25,0,0,0-.25-.25Z']],
  ColorBrush1: ['color-brush-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3,14.5H21a1,1,0,0,0,1-1v-1A2.5,2.5,0,0,0,19.5,10H14.829a.251.251,0,0,1-.249-.275l.619-6.19a3.215,3.215,0,1,0-6.4,0l.619,6.19a.253.253,0,0,1-.063.193A.251.251,0,0,1,9.172,10H4.5A2.5,2.5,0,0,0,2,12.5v1A1,1,0,0,0,3,14.5ZM13,3.75a1,1,0,1,1-1-1A1,1,0,0,1,13,3.75Z', 'M22.368,22.459A8.6,8.6,0,0,1,21,17.8V16.5a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5v1.3A8.607,8.607,0,0,1,1.632,22.46,1,1,0,0,0,2.474,24H3.968A3.494,3.494,0,0,0,6.88,22.442c.212-.317.439-.662.66-1a.25.25,0,0,1,.46.136V23a1,1,0,0,0,1,1H21.526A1,1,0,0,0,22.368,22.459Z']],
  ColorPicker5Alternate: ['color-picker-5-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,8a1,1,0,0,0,0-2h-.75A.25.25,0,0,1,16,5.75V4.5A4.277,4.277,0,0,0,12,0,4.277,4.277,0,0,0,8,4.5V5.75A.25.25,0,0,1,7.75,6H7A1,1,0,0,0,7,8Z', 'M8.25,9.5A.25.25,0,0,0,8,9.75V14a5.189,5.189,0,0,0,1.9,4.042.25.25,0,0,1,.1.2V19a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-.757a.25.25,0,0,1,.1-.2A5.189,5.189,0,0,0,16,14V9.75a.25.25,0,0,0-.25-.25Zm2.25,3.25a.25.25,0,0,1,.25-.25h2.5a.25.25,0,0,1,.25.25V15a1.5,1.5,0,0,1-3,0Z', 'M12,21a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V22A1,1,0,0,0,12,21Z']],
  ColorBrush: ['color-brush', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.764,10H15.093a.249.249,0,0,1-.249-.275l.619-6.19a3.215,3.215,0,1,0-6.4,0l.619,6.19A.251.251,0,0,1,9.435,10H4.764a2.5,2.5,0,0,0-2.5,2.5v1a1,1,0,0,0,1,1h18a1,1,0,0,0,1-1v-1A2.5,2.5,0,0,0,19.764,10Zm-6.5-6.25a1,1,0,1,1-1-1A1,1,0,0,1,13.264,3.75Z', 'M21.264,16.5a.5.5,0,0,0-.5-.5h-17a.5.5,0,0,0-.5.5v1.3A8.607,8.607,0,0,1,1.9,22.46,1,1,0,0,0,2.737,24h1.5a3.493,3.493,0,0,0,2.911-1.558c.213-.317.439-.662.661-1a.25.25,0,0,1,.46.136V23a1,1,0,0,0,1,1h4.25a.25.25,0,0,0,.25-.25v-2.5a.5.5,0,0,1,1,0v2.5a.249.249,0,0,0,.25.25h2a.25.25,0,0,0,.25-.25V19.5a.5.5,0,0,1,1,0v4.25a.249.249,0,0,0,.25.25h1.75a1,1,0,0,0,1-1Z']],
  ColorBrush2: ['color-brush-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.06.872a3.071,3.071,0,0,0-4.564.345L8.571,14.228a.251.251,0,0,0,.086.375,5.136,5.136,0,0,1,2.406,2.452.25.25,0,0,0,.406.073L23.1,5.256A3.072,3.072,0,0,0,23.06.872Z', 'M7.876,15.877a3.649,3.649,0,0,0-4.824,1.836c-.192.426-.335.828-.468,1.2-.394,1.109-.574,1.616-1.578,1.874A1.338,1.338,0,0,0,.782,23.3a7.513,7.513,0,0,0,3.137.7,6.992,6.992,0,0,0,2.469-.447A5.945,5.945,0,0,0,9.711,20.7a3.649,3.649,0,0,0-1.835-4.824Z']],
  ColorPaintingPalette: ['color-painting-palette', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.92,11.237A12.337,12.337,0,0,0,14.935.868,9.789,9.789,0,0,0,9.159.84a12.483,12.483,0,0,0-8.8,8.906A11.918,11.918,0,0,0,3.518,21.131a2.487,2.487,0,0,0,3.081.358,1.5,1.5,0,0,0,.256-2.334l-.809-.81a1,1,0,0,1,0-1.414,1.1,1.1,0,0,1,1.6-.189c1.41,1.409,5.62,5.656,5.622,5.657a3.985,3.985,0,0,0,2.815,1.183,3.751,3.751,0,0,0,1.928-.53A12.018,12.018,0,0,0,23.92,11.237Zm-9.443,7.626a2.506,2.506,0,0,1,0-3.537,2.562,2.562,0,0,1,3.535,0,2.5,2.5,0,1,1-3.535,3.537ZM14.245,7.2a2,2,0,0,1,2-2h0a2,2,0,1,1-2,2Zm3.7,6.01h0a1.5,1.5,0,1,1,2.121,0A1.5,1.5,0,0,1,17.942,13.205ZM11.649,4.72a2,2,0,1,1-2.827,0A2.048,2.048,0,0,1,11.649,4.72Z']],
  ColorPaintingPalette1: ['color-painting-palette-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM8,12.5a3,3,0,1,1-3,3A3,3,0,0,1,8,12.5Zm1-5a3,3,0,1,1,3,3A3,3,0,0,1,9,7.5Zm7,11a3,3,0,1,1,3-3A3,3,0,0,1,16,18.5Z']],
  ColorPalette1: ['color-palette-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,12a2.492,2.492,0,0,0-4.816-.909.251.251,0,0,1-.233.159H13a.25.25,0,0,1-.25-.25V5.549a.251.251,0,0,1,.159-.233,2.5,2.5,0,1,0-1.818,0,.251.251,0,0,1,.159.233V11a.25.25,0,0,1-.25.25H5.549a.251.251,0,0,1-.233-.159,2.5,2.5,0,1,0,0,1.818.251.251,0,0,1,.233-.159H11a.25.25,0,0,1,.25.25v5.451a.251.251,0,0,1-.159.233,2.5,2.5,0,1,0,1.818,0,.251.251,0,0,1-.159-.233V13a.25.25,0,0,1,.25-.25h5.451a.251.251,0,0,1,.233.159A2.492,2.492,0,0,0,23.5,12Z', 'M16.6,20.132A2.5,2.5,0,0,0,20.132,16.6a2.554,2.554,0,0,0-2.758-.5.249.249,0,0,1-.273-.054L15.03,13.97a.75.75,0,0,0-1.06,1.06l2.06,2.06a.25.25,0,0,1,.051.279,2.438,2.438,0,0,0-.217,1A2.484,2.484,0,0,0,16.6,20.132Z', 'M7.4,3.868a2.56,2.56,0,0,0-3.535,0A2.5,2.5,0,0,0,5.636,8.136a2.438,2.438,0,0,0,1-.217.25.25,0,0,1,.279.051l2.06,2.06a.75.75,0,0,0,1.06-1.06L7.97,6.91a.25.25,0,0,1-.051-.279,2.438,2.438,0,0,0,.217-1A2.484,2.484,0,0,0,7.4,3.868Z', 'M13.97,8.97a.75.75,0,1,0,1.06,1.06l2.06-2.06a.25.25,0,0,1,.279-.051,2.438,2.438,0,0,0,1,.217,2.5,2.5,0,0,0,1.768-4.268,2.558,2.558,0,0,0-3.535,0,2.484,2.484,0,0,0-.733,1.768,2.438,2.438,0,0,0,.217,1,.25.25,0,0,1-.051.279Z', 'M10.03,13.97a.749.749,0,0,0-1.06,0L6.9,16.04a.249.249,0,0,1-.273.054,2.556,2.556,0,0,0-2.758.5,2.5,2.5,0,1,0,4.268,1.767,2.438,2.438,0,0,0-.217-1,.25.25,0,0,1,.051-.279l2.06-2.06A.749.749,0,0,0,10.03,13.97Z']],
  ColorDropPick: ['color-drop-pick', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,6.372a.248.248,0,0,0-.044-.141c-.5-.722-1.008-1.414-1.509-2.057A.25.25,0,0,0,16,4.328V22.736a.253.253,0,0,0,.115.211.25.25,0,0,0,.24.016,9.224,9.224,0,0,0,1.542-.905.249.249,0,0,0,.1-.2Z', 'M14.5,1.927a.249.249,0,0,0-.063-.166c-.486-.55-.912-1.009-1.22-1.333a1.474,1.474,0,0,0-.345-.266A.25.25,0,0,0,12.5.381V23.619a.25.25,0,0,0,.267.25,10.754,10.754,0,0,0,1.537-.218.249.249,0,0,0,.2-.244Z', 'M11,.515a.126.126,0,0,0-.217-.087C8.839,2.468,2.5,9.539,2.5,14.906a8.946,8.946,0,0,0,8.221,8.927A.251.251,0,0,0,11,23.584Z', 'M19.5,19.806a.25.25,0,0,0,.456.142A8.8,8.8,0,0,0,21.5,14.906,12.273,12.273,0,0,0,19.973,9.6a.25.25,0,0,0-.473.112Z']],
  ColorPicker5: ['color-picker-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,7a1,1,0,0,0-1-1h-.75a.25.25,0,0,1-.25-.25V5A4.775,4.775,0,0,0,12,0,4.775,4.775,0,0,0,7.5,5v.75A.25.25,0,0,1,7.25,6H6.5a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25V13a5.121,5.121,0,0,0,1.415,3.96A.251.251,0,0,1,9,17.148V18.5A1.5,1.5,0,0,0,10.5,20h3A1.5,1.5,0,0,0,15,18.5V17.148a.251.251,0,0,1,.085-.188A5.121,5.121,0,0,0,16.5,13V8.25A.25.25,0,0,1,16.75,8h.75A1,1,0,0,0,18.5,7Zm-4,6c0,1.343-.35,2.3-.961,2.612A1,1,0,0,0,13,16.5v1.25a.25.25,0,0,1-.25.25h-1.5a.25.25,0,0,1-.25-.25V16.5a1,1,0,0,0-.539-.888C9.85,15.3,9.5,14.343,9.5,13V8.25A.25.25,0,0,1,9.75,8h4.5a.25.25,0,0,1,.25.25Z', 'M12,14a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v2A1,1,0,0,0,12,14Z', 'M12,21a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V22A1,1,0,0,0,12,21Z']],
  ColorPicker: ['color-picker', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,9a1,1,0,0,0-1-1h-.75a.25.25,0,0,1-.25-.25V5A4.775,4.775,0,0,0,12,0,4.775,4.775,0,0,0,7.5,5V7.75A.25.25,0,0,1,7.25,8H6.5a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25V17A5.036,5.036,0,0,0,9,21.032V22.5A1.5,1.5,0,0,0,10.5,24h3A1.5,1.5,0,0,0,15,22.5V21.032A5.036,5.036,0,0,0,16.5,17V10.25a.25.25,0,0,1,.25-.25h.75A1,1,0,0,0,18.5,9Zm-4,8c0,1.343-.35,2.3-.961,2.612A1,1,0,0,0,13,20.5v1.25a.25.25,0,0,1-.25.25h-1.5a.25.25,0,0,1-.25-.25V20.5a1,1,0,0,0-.539-.888C9.85,19.3,9.5,18.343,9.5,17V16H11a.75.75,0,0,0,0-1.5H9.5V13H11a.75.75,0,0,0,0-1.5H9.5V10.25A.25.25,0,0,1,9.75,10h4.5a.25.25,0,0,1,.25.25Z']],
  ColorRollingBrush: ['color-rolling-brush', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,2.5H21.75a.25.25,0,0,0-.25.25v1.5a.25.25,0,0,0,.25.25H23a1,1,0,0,0,0-2Z', 'M3,2.5a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h8a1,1,0,0,1,1,1v.325a.25.25,0,0,0,.3.245,3.535,3.535,0,0,1,1.4,0,.25.25,0,0,0,.3-.245V11.5a3,3,0,0,0-3-3H3a1,1,0,0,1-1-1v-2a1,1,0,0,1,1-1h.25a.25.25,0,0,0,.25-.25V2.75a.25.25,0,0,0-.25-.25Z', 'M4.500 0.000 L20.500 0.000 L20.500 7.000 L4.500 7.000 Z', 'M10.5,15.5v7A1.5,1.5,0,0,0,12,24h2a1.5,1.5,0,0,0,1.5-1.5v-7a2.5,2.5,0,0,0-5,0Z']],
  ColorPicker2: ['color-picker-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.781,1.219a4.776,4.776,0,0,0-6.718.353L14.077,3.559a.247.247,0,0,1-.176.074.253.253,0,0,1-.177-.073l-.53-.531A1,1,0,0,0,11.78,4.443l.53.531a.25.25,0,0,1,0,.353L3.268,14.37a5.035,5.035,0,0,0-1.791,3.911L.439,19.32a1.5,1.5,0,0,0,0,2.121l2.122,2.122a1.506,1.506,0,0,0,2.121,0L5.72,22.524a5.039,5.039,0,0,0,3.911-1.79l9.043-9.043a.25.25,0,0,1,.353,0l.531.531a1,1,0,1,0,1.414-1.414l-.531-.531a.25.25,0,0,1,0-.353l1.987-1.987A4.776,4.776,0,0,0,22.781,1.219ZM8.217,19.319c-.95.952-1.875,1.376-2.526,1.168a1,1,0,0,0-1.009.247l-.884.884a.249.249,0,0,1-.353,0l-1.062-1.06a.25.25,0,0,1,0-.354l.884-.885a1,1,0,0,0,.247-1.007c-.208-.658.218-1.579,1.168-2.528l1.556-1.555a.249.249,0,0,1,.353,0l1.341,1.34a.75.75,0,0,0,1.06-1.06l-1.34-1.341a.25.25,0,0,1,0-.354l.586-.585a.249.249,0,0,1,.353,0l1.341,1.34a.75.75,0,0,0,1.06-1.06l-1.34-1.341a.25.25,0,0,1,0-.354l.586-.585a.249.249,0,0,1,.353,0l1.341,1.34a.75.75,0,0,0,1.06-1.06l-1.34-1.341a.25.25,0,0,1,0-.354l2.072-2.072a.25.25,0,0,1,.353,0l3.182,3.182a.249.249,0,0,1,0,.353Z']],
  ColorPicker3: ['color-picker-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,9a1,1,0,0,0-1-1h-.75a.25.25,0,0,1-.25-.25V5A4.775,4.775,0,0,0,12,0,4.775,4.775,0,0,0,7.5,5V7.75A.25.25,0,0,1,7.25,8H6.5a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25V17A5.032,5.032,0,0,0,9,21.032V22.5A1.5,1.5,0,0,0,10.5,24h3A1.5,1.5,0,0,0,15,22.5V21.032A5.032,5.032,0,0,0,16.5,17V10.25a.25.25,0,0,1,.25-.25h.75A1,1,0,0,0,18.5,9Zm-4,8c0,1.343-.351,2.3-.961,2.612A1,1,0,0,0,13,20.5v1.25a.25.25,0,0,1-.25.25h-1.5a.25.25,0,0,1-.25-.25V20.5a1,1,0,0,0-.539-.888C9.851,19.3,9.5,18.343,9.5,17V10.25A.25.25,0,0,1,9.75,10h4.5a.25.25,0,0,1,.25.25Z']],
  ColorPicker4: ['color-picker-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,9a1,1,0,0,0,0-2h-.75A.25.25,0,0,1,16,6.75V4.5A4.277,4.277,0,0,0,12,0,4.277,4.277,0,0,0,8,4.5V6.75A.25.25,0,0,1,7.75,7H7A1,1,0,0,0,7,9Z', 'M8.25,10.5a.25.25,0,0,0-.25.25V17.5a5.19,5.19,0,0,0,1.9,4.042.25.25,0,0,1,.1.2V23a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V21.743a.25.25,0,0,1,.1-.2A5.19,5.19,0,0,0,16,17.5V10.75a.25.25,0,0,0-.25-.25Zm2.25,3.75a.25.25,0,0,1,.25-.25h2.5a.25.25,0,0,1,.25.25V18a1.5,1.5,0,0,1-3,0Z']],
  ColorPaletteSample2: ['color-palette-sample-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.173,19.367a2.5,2.5,0,0,0,1.733-3.081l-1.347-4.815a2.5,2.5,0,0,0-3.081-1.734l-.753.211.526-.653a2.5,2.5,0,0,0-.377-3.515L14.983,2.642a2.5,2.5,0,0,0-3.516.376L10.445,4.285A.25.25,0,0,1,10,4.128V2.5A2.5,2.5,0,0,0,7.5,0h-5A2.5,2.5,0,0,0,0,2.5V18.807a5.145,5.145,0,0,0,4.51,5.17c.166.015.332.023.5.023C6,24,5.5,24,22.173,19.367ZM13.024,4.273a.5.5,0,0,1,.7-.075l3.892,3.14a.5.5,0,0,1,.075.7l-7.249,8.988A.249.249,0,0,1,10,16.871V8.11a.248.248,0,0,1,.055-.157ZM7,5a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,3,5V3a.5.5,0,0,1,.5-.5h3A.5.5,0,0,1,7,3ZM3.5,8h3a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-2A.5.5,0,0,1,3.5,8Zm0,5.5h3A.5.5,0,0,1,7,14v2a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,3,16V14A.5.5,0,0,1,3.5,13.5Zm1.5,5A1.5,1.5,0,1,1,3.5,20,1.5,1.5,0,0,1,5,18.5Zm16.981-1.675a.5.5,0,0,1-.347.616L10.823,20.467a.25.25,0,0,1-.262-.4l5.95-7.376a.25.25,0,0,1,.127-.084l3.378-.946a.5.5,0,0,1,.617.347Z']],
  ColorBrushPaint1Alternate: ['color-brush-paint-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.95,16.758a2.415,2.415,0,0,1-.756-4.428.251.251,0,0,0,.118-.178,9.186,9.186,0,0,1,.359-1.91A.182.182,0,0,0,12.5,10a5.51,5.51,0,0,0-4.831,2.869.25.25,0,0,1-.22.131H2a2,2,0,0,0-2,2v7a2,2,0,0,0,2,2H13a2,2,0,0,0,2-2V20.55a.248.248,0,0,1,.131-.219,5.513,5.513,0,0,0,2.808-4.022.25.25,0,0,0-.362-.259A6.283,6.283,0,0,1,12.95,16.758Z', 'M23.807,2A1.317,1.317,0,0,0,21.569.614L17.088,7.269a.25.25,0,0,0,.159.384,4.023,4.023,0,0,1,2.192,1.24.25.25,0,0,0,.4-.044Z', 'M17.022,8.9a2.792,2.792,0,0,0-3.293,2.184c-.066.328-.1.633-.137.914-.1.842-.154,1.1-.676,1.364a1.166,1.166,0,0,0,.292,2.178,5.766,5.766,0,0,0,1.176.123,5.228,5.228,0,0,0,2.885-.852,4.428,4.428,0,0,0,1.939-2.618A2.8,2.8,0,0,0,17.022,8.9Z']],
  ColorBucket: ['color-bucket', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.382,17.9a1.083,1.083,0,0,0-1.764,0A8.616,8.616,0,0,0,19,21.472a2.5,2.5,0,0,0,5,0A8.6,8.6,0,0,0,22.382,17.9Z', 'M14.924,7.1a18.912,18.912,0,0,0,6.688,4.488.251.251,0,0,0,.307-.329c-.858-2.251-4.353-5.8-4.855-6.3-.525-.526-4.395-4.34-6.641-4.927a.25.25,0,0,0-.308.3C10.411,1.657,12.451,4.63,14.924,7.1Z', 'M13.864,8.164a24.375,24.375,0,0,1-5-6.852.25.25,0,0,0-.434-.054L.3,12.412c-1.193,1.193,1.416,4.439,3.145,6.169,1.856,1.856,4.1,3.456,5.4,3.456a.958.958,0,0,0,.714-.262l11.486-8.381a.25.25,0,0,0-.07-.439A20.932,20.932,0,0,1,13.864,8.164Z']],
  ColorSpray: ['color-spray', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.000 4.000 L7.000 4.000 L7.000 7.000 L4.000 7.000 Z', 'M15.316,8.051l-3-1a1,1,0,0,0-.632,1.9l3,1a1,1,0,0,0,.632-1.9Z', 'M14.684,2.051l-3,1a1,1,0,0,0,.632,1.9l3-1a1,1,0,0,0-.632-1.9Z', 'M-0.000 12.000 L11.000 12.000 L11.000 24.000 L-0.000 24.000 Z', 'M2,11H9a.5.5,0,0,0,.447-.724L8.724,8.83A1.491,1.491,0,0,0,7.382,8H3.618a1.492,1.492,0,0,0-1.342.829l-.723,1.447A.5.5,0,0,0,2,11Z', 'M21.387,2.613A3.507,3.507,0,0,0,18,0a1,1,0,0,0,0,2,1.5,1.5,0,0,1,1.5,1.5,1,1,0,0,0,1,1,1.5,1.5,0,0,1,0,3,1,1,0,0,0-1,1A1.5,1.5,0,0,1,18,10a1,1,0,0,0,0,2,3.507,3.507,0,0,0,3.387-2.613,3.5,3.5,0,0,0,0-6.774Z']],
  ColorTriangle: ['color-triangle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.8,4.279a.252.252,0,0,0,.1-.178.248.248,0,0,0-.065-.2A11.913,11.913,0,0,0,7.183,1.024a.25.25,0,0,0-.118.35L8.525,4a.249.249,0,0,0,.311.11A8.481,8.481,0,0,1,18,5.986a.252.252,0,0,0,.32.028Z', 'M13.683,20.556a.249.249,0,0,0-.28-.175A8.5,8.5,0,0,1,7.129,5.037.25.25,0,0,0,7.2,4.711L5.748,2.09a.253.253,0,0,0-.16-.122.249.249,0,0,0-.2.035A11.988,11.988,0,0,0,12,24a11.834,11.834,0,0,0,2.359-.242.247.247,0,0,0,.165-.116.253.253,0,0,0,.025-.2Z', 'M15.989,23.02a.252.252,0,0,0,.33.161A11.979,11.979,0,0,0,22.094,5.516a.251.251,0,0,0-.162-.109.247.247,0,0,0-.192.04L19.281,7.168a.251.251,0,0,0-.069.338,8.488,8.488,0,0,1-3.943,12.333.25.25,0,0,0-.143.3Z', 'M17.052,16.194a.949.949,0,0,0,.835-1.4L12.835,5.414a.948.948,0,0,0-1.67,0L6.113,14.8a.949.949,0,0,0,.835,1.4Z']],
  ColorTubePainting: ['color-tube-painting', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.232,3.421l-3.285-1.71a1.424,1.424,0,0,0-1.923.606h0l-.936,1.8a.247.247,0,0,0-.017.19.249.249,0,0,0,.123.147l5.371,2.8a.25.25,0,0,0,.337-.107l.936-1.8A1.423,1.423,0,0,0,23.232,3.421Z', 'M12.885,12.73a.253.253,0,0,0-.191-.016.247.247,0,0,0-.146.123l-.936,1.8a1.424,1.424,0,0,0,.606,1.923l3.285,1.71a1.428,1.428,0,0,0,1.923-.606l.936-1.8a.25.25,0,0,0-.106-.337Z', 'M16.732,5.34a.25.25,0,0,0-.337.106l-3.154,6.06a.249.249,0,0,0-.017.191.252.252,0,0,0,.123.147l5.371,2.8a.25.25,0,0,0,.337-.106l3.154-6.061a.246.246,0,0,0,.017-.19.252.252,0,0,0-.123-.147Z', 'M14.981,19.33,11.7,17.621a.5.5,0,0,0-.721.346l-.5,2.5a1.634,1.634,0,0,0,.819,1.877,1.616,1.616,0,0,0,1.986-.385L15.1,20.127A.5.5,0,0,0,14.981,19.33Z', 'M3.01,3.736a2.006,2.006,0,0,1,2.009.014C6.819,4.81,8.725,5.936,9.841,6.6A1.827,1.827,0,0,1,10.82,7.9a.779.779,0,0,1-.208.659,1,1,0,0,0,1.338,1.487A2.785,2.785,0,0,0,12.811,7.7a3.783,3.783,0,0,0-1.943-2.816c-1.118-.67-3.029-1.8-4.833-2.861A4,4,0,0,0,0,5.471,3.744,3.744,0,0,0,1.767,8.828a43.521,43.521,0,0,1,4.75,3.306.526.526,0,0,1,.048.667c-.248.354-.849.1-1.1-.026a3.078,3.078,0,0,0-4.144,1.2c-.717,1.269-.545,3.11,1.456,4.361A19.874,19.874,0,0,0,7.192,20.4a1,1,0,0,0,.616-1.9A17.923,17.923,0,0,1,3.843,16.64c-.8-.5-1.089-1.127-.776-1.68a1.1,1.1,0,0,1,1.5-.4,2.7,2.7,0,0,0,3.644-.61,2.519,2.519,0,0,0-.33-3.278,45.052,45.052,0,0,0-5.06-3.542A1.759,1.759,0,0,1,2,5.471,2,2,0,0,1,3.01,3.736Z']],
  ColorTubePaintingAlternate: ['color-tube-painting-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.232,3.421,19.947,1.71a1.425,1.425,0,0,0-1.923.608l-.936,1.8a.259.259,0,0,0-.017.191.256.256,0,0,0,.123.147l5.371,2.8a.25.25,0,0,0,.337-.106l.936-1.8A1.424,1.424,0,0,0,23.232,3.421Z', 'M12.885,12.731a.247.247,0,0,0-.19-.017.249.249,0,0,0-.147.123l-.936,1.8a1.426,1.426,0,0,0,.606,1.923l3.285,1.71a1.427,1.427,0,0,0,1.923-.607l.936-1.8a.251.251,0,0,0-.106-.338Z', 'M16.733,5.34a.25.25,0,0,0-.338.107l-3.154,6.06a.249.249,0,0,0,.106.337l5.371,2.8a.25.25,0,0,0,.337-.107l3.155-6.06a.253.253,0,0,0,.016-.191.247.247,0,0,0-.123-.146Z', 'M14.981,19.33,11.7,17.62a.5.5,0,0,0-.722.346l-.5,2.5a1.634,1.634,0,0,0,.819,1.877,1.617,1.617,0,0,0,1.987-.385L15.1,20.127A.5.5,0,0,0,14.981,19.33Z', 'M11.177,11.8a2.94,2.94,0,0,1-.964-2.023A1.4,1.4,0,0,1,10.7,8.736a2.017,2.017,0,0,0,.618-1.7,3.041,3.041,0,0,0-1.583-2.25C8.615,4.113,6.707,2.986,4.9,1.923A3.253,3.253,0,0,0,0,4.722,3,3,0,0,0,1.41,7.441a43.036,43.036,0,0,1,4.867,3.394,1.283,1.283,0,0,1,.153,1.647c-.4.58-1.171.66-2.051.211a2.339,2.339,0,0,0-3.15.9c-.542.958-.38,2.367,1.2,3.355a22.916,22.916,0,0,0,6.417,2.816.25.25,0,0,0,.288-.238,22.777,22.777,0,0,1,2.094-7.455A.25.25,0,0,0,11.177,11.8Z']],
  ColorPickerTake: ['color-picker-take', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,8h-.75a.25.25,0,0,1-.25-.25V5A4.775,4.775,0,0,0,12,0,4.775,4.775,0,0,0,7.5,5V7.75A.25.25,0,0,1,7.25,8H6.5a1,1,0,0,0,0,2h.75a.25.25,0,0,1,.25.25V17a5.121,5.121,0,0,0,1.415,3.96A.251.251,0,0,1,9,21.148V22.5A1.5,1.5,0,0,0,10.5,24h3A1.5,1.5,0,0,0,15,22.5V21.148a.251.251,0,0,1,.085-.188A5.121,5.121,0,0,0,16.5,17V10.25a.25.25,0,0,1,.25-.25h.75a1,1,0,0,0,0-2Zm-3,9c0,1.343-.35,2.3-.961,2.612A1,1,0,0,0,13,20.5v1.25a.25.25,0,0,1-.25.25h-1.5a.25.25,0,0,1-.25-.25V20.5a1,1,0,0,0-.539-.888C9.85,19.3,9.5,18.343,9.5,17V10.25A.25.25,0,0,1,9.75,10h4.5a.25.25,0,0,1,.25.25Z', 'M12,18.5a1,1,0,0,0,1-1V13a1,1,0,0,0-2,0v4.5A1,1,0,0,0,12,18.5Z']],
  ColorTube: ['color-tube', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.369,17.831,17.1,12.362a.5.5,0,0,0,.009-.715l-7-7a.508.508,0,0,0-.716.007L3.912,10.389a4.473,4.473,0,0,0-.959,1.951l-.691,3.05a.5.5,0,0,0,.134.464l3.5,3.5a.5.5,0,0,0,.464.134L9.382,18.8A4.473,4.473,0,0,0,11.369,17.831Z', 'M18.731,11.222a1,1,0,0,0,1.415,0h0l1.166-1.166a1.5,1.5,0,0,0,0-2.121L13.817.439a1.5,1.5,0,0,0-2.121,0L10.528,1.605a1,1,0,0,0,0,1.414Z', 'M1.805,16.945a.507.507,0,0,0-.72.013l-.4.426a1.5,1.5,0,0,0,0,2.122l1.557,1.555a1.5,1.5,0,0,0,1.065.44,1.469,1.469,0,0,0,1.043-.428l.438-.408a.5.5,0,0,0,.013-.72Z', 'M23.457,21.569a1,1,0,0,0-1.414,0,1.513,1.513,0,0,1-2.086,0,3.556,3.556,0,0,0-4.914,0,1.513,1.513,0,0,1-2.086,0,3.556,3.556,0,0,0-4.914,0,1,1,0,0,0,1.414,1.414,1.509,1.509,0,0,1,2.086,0,3.56,3.56,0,0,0,4.914,0,1.509,1.509,0,0,1,2.086,0,3.476,3.476,0,0,0,4.914,0A1,1,0,0,0,23.457,21.569Z']],
  ColorBrushPaint: ['color-brush-paint', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.817,2.979a1.659,1.659,0,0,0-2.942-1.535l-6,10.5a.25.25,0,0,0,.194.373A5.151,5.151,0,0,1,18.21,13.77a.251.251,0,0,0,.4-.069Z', 'M15.06,13.821a3.654,3.654,0,0,0-4.081,3.16c-.059.463-.08.889-.1,1.284-.054,1.176-.079,1.713-.964,2.252a1.339,1.339,0,0,0,.517,2.471,7.856,7.856,0,0,0,1.055.071A7.143,7.143,0,0,0,15.872,21.6a5.956,5.956,0,0,0,2.349-3.7A3.654,3.654,0,0,0,15.06,13.821Z', 'M2.417,15.106c.453-.11.464-.105.95.522.7.906,1.767,2.275,4.95,2.592a1,1,0,0,0,.2-1.991A4.269,4.269,0,0,1,4.946,14.4a2.609,2.609,0,0,0-3-1.237A2.5,2.5,0,0,0,.32,14.436a3.237,3.237,0,0,0-.1,2.581c.752,2.207,3.563,4.809,6.837,6.329a1,1,0,1,0,.726-1.869C5.1,20.2,2.673,18.023,2.11,16.372,1.772,15.38,2.272,15.142,2.417,15.106Z']],
  ColorDropOff: ['color-drop-off', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,15.361a.249.249,0,0,0,.073.177l1.333,1.332a.251.251,0,0,0,.422-.128A9.027,9.027,0,0,0,21,15a12.277,12.277,0,0,0-1.527-5.31A.25.25,0,0,0,19,9.8Z', 'M14,17.639a.249.249,0,0,0-.073-.177l-1.5-1.5a.25.25,0,0,0-.427.177v7.574a.25.25,0,0,0,.079.182.248.248,0,0,0,.188.067,10.477,10.477,0,0,0,1.537-.218A.248.248,0,0,0,14,23.5Z', 'M17.5,21.139a.249.249,0,0,0-.073-.177l-1.5-1.5a.25.25,0,0,0-.427.177V22.83a.25.25,0,0,0,.355.226,9.171,9.171,0,0,0,1.555-.914.218.218,0,0,0,.09-.177Z', 'M10.5,14.139a.249.249,0,0,0-.073-.177L4.693,8.228a.25.25,0,0,0-.392.05A14.168,14.168,0,0,0,2,15a8.945,8.945,0,0,0,8.221,8.926.249.249,0,0,0,.279-.248Z', 'M10.073,6.538a.25.25,0,0,0,.427-.177V.609a.126.126,0,0,0-.217-.088c-.6.633-1.629,1.754-2.757,3.153a.251.251,0,0,0,.017.334Z', 'M15.5,11.861a.249.249,0,0,0,.073.177l1.5,1.5a.25.25,0,0,0,.427-.177V6.466a.243.243,0,0,0-.044-.141c-.5-.723-1.008-1.415-1.509-2.057a.25.25,0,0,0-.447.154Z', 'M12,8.361a.249.249,0,0,0,.073.177l1.5,1.5A.25.25,0,0,0,14,9.861V2.02a.245.245,0,0,0-.063-.165c-.486-.55-.912-1.01-1.22-1.334a1.443,1.443,0,0,0-.345-.265A.25.25,0,0,0,12,.474Z', 'M1.707.293A1,1,0,0,0,.293,1.707l22,22a1,1,0,0,0,1.414-1.414Z']],
  ColorPalette: ['color-palette', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.587,8.706a.22.22,0,0,1-.087-.184V8.5a8.5,8.5,0,0,0-17,0v.01a.248.248,0,0,1-.1.205,8.487,8.487,0,0,0,8.5,14.567.251.251,0,0,1,.2,0A8.488,8.488,0,0,0,20.587,8.706Zm-8.446,12.17a.254.254,0,0,1-.282,0A6.507,6.507,0,0,1,9.16,16.9a.251.251,0,0,1,.319-.293,8.3,8.3,0,0,0,5.042,0,.251.251,0,0,1,.319.293A6.507,6.507,0,0,1,12.141,20.876Zm2.707-6.755a.251.251,0,0,1-.14.28,6.421,6.421,0,0,1-5.416,0,.25.25,0,0,1-.14-.28,6.516,6.516,0,0,1,2.707-4,.254.254,0,0,1,.282,0A6.516,6.516,0,0,1,14.848,14.121ZM7.5,12.649a.25.25,0,0,1-.425.079A6.5,6.5,0,0,1,5.652,9.879a.251.251,0,0,1,.14-.28A6.4,6.4,0,0,1,9.371,9.06a.25.25,0,0,1,.142.425A8.5,8.5,0,0,0,7.5,12.649Zm6.992-3.164a.251.251,0,0,1,.142-.425,6.4,6.4,0,0,1,3.579.539.25.25,0,0,1,.14.28,6.5,6.5,0,0,1-1.418,2.849.25.25,0,0,1-.425-.079A8.5,8.5,0,0,0,14.487,9.485ZM12,2a6.505,6.505,0,0,1,6.34,5.1.251.251,0,0,1-.319.293,8.364,8.364,0,0,0-5.921.326.251.251,0,0,1-.2,0,8.361,8.361,0,0,0-5.92-.326A.251.251,0,0,1,5.66,7.1,6.505,6.505,0,0,1,12,2ZM8.5,22A6.494,6.494,0,0,1,3.57,11.272.25.25,0,0,1,4,11.351,8.528,8.528,0,0,0,6.9,15.285a.248.248,0,0,1,.1.205v.01a8.456,8.456,0,0,0,2.513,6.015.251.251,0,0,1-.142.425A6.424,6.424,0,0,1,8.5,22Zm7,0a6.424,6.424,0,0,1-.871-.06.25.25,0,0,1-.142-.425A8.456,8.456,0,0,0,17,15.5v-.01a.248.248,0,0,1,.1-.205,8.528,8.528,0,0,0,2.906-3.934.25.25,0,0,1,.425-.079A6.494,6.494,0,0,1,15.5,22Z']],
  ColorPicker3Alternate: ['color-picker-3-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17,9a1,1,0,0,0,0-2h-.75A.25.25,0,0,1,16,6.75V4.5A4.277,4.277,0,0,0,12,0,4.277,4.277,0,0,0,8,4.5V6.75A.25.25,0,0,1,7.75,7H7A1,1,0,0,0,7,9Z', 'M8.25,10.5a.25.25,0,0,0-.25.25V17.5a5.182,5.182,0,0,0,1.9,4.041.251.251,0,0,1,.1.2V23a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V21.743a.251.251,0,0,1,.1-.2A5.182,5.182,0,0,0,16,17.5V10.75a.25.25,0,0,0-.25-.25Z']],
  ColorPalette2: ['color-palette-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM22,12a10,10,0,0,1-.346,2.611.252.252,0,0,1-.132.159.247.247,0,0,1-.206.006l-5.667-2.347a.25.25,0,0,1-.154-.244c0-.061.005-.123.005-.185s0-.124-.005-.185a.25.25,0,0,1,.154-.244l5.667-2.347a.247.247,0,0,1,.206.006.252.252,0,0,1,.132.159A10,10,0,0,1,22,12ZM2,12a10,10,0,0,1,.346-2.611.252.252,0,0,1,.132-.159.247.247,0,0,1,.206-.006l5.667,2.347a.25.25,0,0,1,.154.244c0,.061-.005.123-.005.185s0,.124.005.185a.25.25,0,0,1-.154.244L2.684,14.776a.247.247,0,0,1-.206-.006.252.252,0,0,1-.132-.159A10,10,0,0,1,2,12ZM20.669,7.021a.25.25,0,0,1,.021.205.256.256,0,0,1-.141.151L14.882,9.724A.248.248,0,0,1,14.6,9.66c-.083-.091-.17-.178-.261-.26a.251.251,0,0,1-.064-.282l2.348-5.666a.246.246,0,0,1,.15-.141.252.252,0,0,1,.206.02A10.075,10.075,0,0,1,20.669,7.021ZM14.611,2.347a.247.247,0,0,1,.16.131.255.255,0,0,1,.006.206L12.421,8.371a.219.219,0,0,1-.215.135c-.068,0-.137-.006-.206-.006s-.124,0-.185.005a.248.248,0,0,1-.244-.154L9.223,2.684a.251.251,0,0,1,.007-.206.243.243,0,0,1,.159-.131,10,10,0,0,1,5.222,0ZM7.02,3.331a.252.252,0,0,1,.206-.02.246.246,0,0,1,.15.141L9.724,9.118A.251.251,0,0,1,9.66,9.4c-.091.082-.178.169-.261.26a.248.248,0,0,1-.281.064L3.451,7.377a.249.249,0,0,1-.12-.356A10.075,10.075,0,0,1,7.02,3.331ZM3.331,16.979a.25.25,0,0,1-.021-.2.256.256,0,0,1,.141-.151l5.771-2.39a.093.093,0,0,1,.107.026,3.553,3.553,0,0,0,.331.341.251.251,0,0,1,.064.282L7.376,20.548a.246.246,0,0,1-.15.141.252.252,0,0,1-.206-.02A10.075,10.075,0,0,1,3.331,16.979Zm6.058,4.674a.247.247,0,0,1-.16-.131.255.255,0,0,1-.006-.206l2.348-5.667a.248.248,0,0,1,.244-.154c.061,0,.123.005.185.005s.138,0,.206-.006a.219.219,0,0,1,.215.135l2.356,5.687a.251.251,0,0,1-.007.206.246.246,0,0,1-.159.131,10,10,0,0,1-5.222,0Zm7.591-.984a.252.252,0,0,1-.206.02.246.246,0,0,1-.15-.141l-2.348-5.666a.251.251,0,0,1,.064-.282c.091-.082.178-.169.261-.26a.248.248,0,0,1,.281-.064l5.667,2.347a.249.249,0,0,1,.12.356A10.075,10.075,0,0,1,16.98,20.669Z']]
};
exports["default"] = _default;